import { createContext, useEffect, useState } from "react";

export const AccountReportContentContext = createContext();

const initialReportContentState = {
  budget: "",
  revisedEstimate: "",
  lfAuditReport: "",
  anyOther:""
};

export const BUDGET = "budget";
export const REVISED_ESTIMATE = "revisedEstimate";
export const LF_AUDIT_REPORT = "lfAuditReport";
export const ANY_OTHER = "anyOther";


export const AccountReportContentContextProvider = ({ children }) => {
  const [content, setContent] = useState(initialReportContentState);

  const setSubTitle = (subTitle, subTitleContent) => {
    setContent((content) => {
      const newContent = {
        ...content,
      };
      newContent[subTitle] = subTitleContent;
      return newContent;
    });
  };

  const getSubTitle = (subTitle) => {
    return content[subTitle];
  };

  useEffect(() => {
    // Get the content from the backend and use setContent to set the same
    console.log(content);
  }, [content]);

  return (
    <AccountReportContentContext.Provider
      value={{ content, setContent, setSubTitle, getSubTitle }}
    >
      {children}
    </AccountReportContentContext.Provider>
  );
};
